import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStorage } from '../../client/repositories/lib/auth';
import { NavItemType } from '../../components/nav-items/models/nav-item-type.enum';
import { NavItemModel } from '../../components/nav-items/models/nav-item.model';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, AfterViewInit {
  isSignedIn = false;

  title = '';

  showCreateAccountButton = true;

  signInItem = {
    name: 'header.signIn',
    type: NavItemType.Link,
    navigateTo: 'auth/signin',
  } as NavItemModel;

  contactItem = {
    name: 'header.contact',
    type: NavItemType.Link,
    navigateTo: '#',
  } as NavItemModel;

  homeItem = {
    name: 'header.home',
    type: NavItemType.Link,
    navigateTo: '/home',
    class: 'nav-header nav-home',
  } as NavItemModel;

  navItems: NavItemModel[] = [this.contactItem, this.signInItem];

  loggedInNavItems: NavItemModel[] = [this.homeItem];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authStorage: AuthStorage
  ) {}

  ngAfterViewInit(): void {}

  signOut(): void {
    this.isSignedIn = false;
    this.authStorage.clear();
    this.router.navigate(['/auth/signin']);
  }

  navigateToPasswordChange(): void {
    this.router.navigate(['/auth/set-new-password']);
  }

  ngOnInit(): void {
    this.route.url.subscribe((data) => {
      if (this.router.url.includes('signin')) {
        this.navItems = [this.contactItem];
      } else if (this.router.url.includes('signup')) {
        this.navItems = [this.contactItem, this.signInItem];
      } else {
        this.navItems = [this.contactItem, this.signInItem];
      }
    });

    if (this.authStorage.getCredential()) {
      this.isSignedIn = true;
    } else {
      this.isSignedIn = false;
    }
  }
}
